<template >
  <v-card min-width="210px" class="rounded-card" :class="{'transparent': !tmr}">
    <v-card-title class="teal mb-1 py-1 body-2">{{group.code}} - {{group.name}}</v-card-title>
    <v-layout>
      <v-flex xs12>
        <v-tooltip top>
          <template v-slot:activator="{ on }">

            <v-badge color="teal darken-2" overlap>
              <template v-slot:badge>
                <span v-on="on">{{groupsMakeCount(group.code, tmrCode)}}</span>
              </template>
              <v-card-text class="pb-1 pt-0 caption ">
                <span>{{$t('TMR')}}: </span>
                <span class="font-weight-medium text-truncate">{{tmrCode + "-" + (tmr ? tmr.name : "")}}</span>
              </v-card-text>
            </v-badge>

          </template>
          <span>{{$t('Number of deliveries for the group')}}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs8>
        <v-card-text class="pb-1 pt-0 caption">
          <span>{{$t('Cows')}}: {{group.cowCount}}</span>
        </v-card-text>
      </v-flex>
      <v-flex xs4>
        <v-card-text
          v-if="deliveryPercent > 0 && deliveryPercent < 100"
          class="pb-1 pt-0 caption info--text font-weight-medium"
        >{{deliveryPercent}}%</v-card-text>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-card-text class="pb-1 pt-0 info--text font-weight-medium text-center">{{total | kgString}}</v-card-text>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "MiniGroupPanel",
  props: ["groupId", "tmrCode"],
  data() {
    return {};
  },
  computed: {
    group() {
      return this.$store.getters.getGroup(this.groupId);
    },
    tmr() {
      return this.$store.getters.getTmrFromCode(this.tmrCode);
    },
    deliveryPercent() {
      if (this.group.defaultTMR.code == this.tmrCode)
        return this.group.defaultTMR.dailyPercent;
      if (this.group.secondTMR.code == this.tmrCode)
        return this.group.secondTMR.dailyPercent;
      else return 0;
    },
    total() {
      //TODO: add daily factor to this calculation..(maybee)
      let delTotal = this.tmr ?
        this.group.cowCount *
        this.tmr.doseweight *
        (this.group.hungerPercent / 100) *
        (this.deliveryPercent / 100)
        : 0;
      return Intl.NumberFormat().format(Math.round(delTotal));
    }
  },
  methods: {
    groupsMakeCount(grpCode, tmrCode) {
      return this.$store.getters.groupsInWagonsCount(grpCode, tmrCode);
    }
  },
  components: {}
};
</script>

<style>
.rounded-card {
  border-radius: 8px;
}
.transparent  {
  opacity: 0.5;
}
</style>
